import { render, staticRenderFns } from "./Printable-attempts-table.vue?vue&type=template&id=6fa55f47"
import script from "./Printable-attempts-table.vue?vue&type=script&lang=js"
export * from "./Printable-attempts-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports